var F = Object.defineProperty;
var B = (n, t, e) => t in n ? F(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var l = (n, t, e) => (B(n, typeof t != "symbol" ? t + "" : t, e), e);
function I(n, t, e, s) {
  function r(i) {
    return i instanceof e ? i : new e(function(h) {
      h(i);
    });
  }
  return new (e || (e = Promise))(function(i, h) {
    function v(p) {
      try {
        o(s.next(p));
      } catch (y) {
        h(y);
      }
    }
    function w(p) {
      try {
        o(s.throw(p));
      } catch (y) {
        h(y);
      }
    }
    function o(p) {
      p.done ? i(p.value) : r(p.value).then(v, w);
    }
    o((s = s.apply(n, t || [])).next());
  });
}
function L(n, t) {
  var e = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, s, r, i, h;
  return h = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (h[Symbol.iterator] = function() {
    return this;
  }), h;
  function v(o) {
    return function(p) {
      return w([o, p]);
    };
  }
  function w(o) {
    if (s)
      throw new TypeError("Generator is already executing.");
    for (; e; )
      try {
        if (s = 1, r && (i = o[0] & 2 ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done)
          return i;
        switch (r = 0, i && (o = [o[0] & 2, i.value]), o[0]) {
          case 0:
          case 1:
            i = o;
            break;
          case 4:
            return e.label++, { value: o[1], done: !1 };
          case 5:
            e.label++, r = o[1], o = [0];
            continue;
          case 7:
            o = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (i = e.trys, !(i = i.length > 0 && i[i.length - 1]) && (o[0] === 6 || o[0] === 2)) {
              e = 0;
              continue;
            }
            if (o[0] === 3 && (!i || o[1] > i[0] && o[1] < i[3])) {
              e.label = o[1];
              break;
            }
            if (o[0] === 6 && e.label < i[1]) {
              e.label = i[1], i = o;
              break;
            }
            if (i && e.label < i[2]) {
              e.label = i[2], e.ops.push(o);
              break;
            }
            i[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        o = t.call(n, e);
      } catch (p) {
        o = [6, p], r = 0;
      } finally {
        s = i = 0;
      }
    if (o[0] & 5)
      throw o[1];
    return { value: o[0] ? o[1] : void 0, done: !0 };
  }
}
var A = new Error("request for lock canceled"), $ = function() {
  function n(t, e) {
    if (e === void 0 && (e = A), this._maxConcurrency = t, this._cancelError = e, this._queue = [], this._waiters = [], t <= 0)
      throw new Error("semaphore must be initialized to a positive value");
    this._value = t;
  }
  return n.prototype.acquire = function() {
    var t = this, e = this.isLocked(), s = new Promise(function(r, i) {
      return t._queue.push({ resolve: r, reject: i });
    });
    return e || this._dispatch(), s;
  }, n.prototype.runExclusive = function(t) {
    return I(this, void 0, void 0, function() {
      var e, s, r;
      return L(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, this.acquire()];
          case 1:
            e = i.sent(), s = e[0], r = e[1], i.label = 2;
          case 2:
            return i.trys.push([2, , 4, 5]), [4, t(s)];
          case 3:
            return [2, i.sent()];
          case 4:
            return r(), [7];
          case 5:
            return [2];
        }
      });
    });
  }, n.prototype.waitForUnlock = function() {
    return I(this, void 0, void 0, function() {
      var t, e = this;
      return L(this, function(s) {
        return this.isLocked() ? (t = new Promise(function(r) {
          return e._waiters.push({ resolve: r });
        }), [2, t]) : [2, Promise.resolve()];
      });
    });
  }, n.prototype.isLocked = function() {
    return this._value <= 0;
  }, n.prototype.release = function() {
    if (this._maxConcurrency > 1)
      throw new Error("this method is unavailable on semaphores with concurrency > 1; use the scoped release returned by acquire instead");
    if (this._currentReleaser) {
      var t = this._currentReleaser;
      this._currentReleaser = void 0, t();
    }
  }, n.prototype.cancel = function() {
    var t = this;
    this._queue.forEach(function(e) {
      return e.reject(t._cancelError);
    }), this._queue = [];
  }, n.prototype._dispatch = function() {
    var t = this, e = this._queue.shift();
    if (!!e) {
      var s = !1;
      this._currentReleaser = function() {
        s || (s = !0, t._value++, t._resolveWaiters(), t._dispatch());
      }, e.resolve([this._value--, this._currentReleaser]);
    }
  }, n.prototype._resolveWaiters = function() {
    this._waiters.forEach(function(t) {
      return t.resolve();
    }), this._waiters = [];
  }, n;
}(), j = function() {
  function n(t) {
    this._semaphore = new $(1, t);
  }
  return n.prototype.acquire = function() {
    return I(this, void 0, void 0, function() {
      var t, e;
      return L(this, function(s) {
        switch (s.label) {
          case 0:
            return [4, this._semaphore.acquire()];
          case 1:
            return t = s.sent(), e = t[1], [2, e];
        }
      });
    });
  }, n.prototype.runExclusive = function(t) {
    return this._semaphore.runExclusive(function() {
      return t();
    });
  }, n.prototype.isLocked = function() {
    return this._semaphore.isLocked();
  }, n.prototype.waitForUnlock = function() {
    return this._semaphore.waitForUnlock();
  }, n.prototype.release = function() {
    this._semaphore.release();
  }, n.prototype.cancel = function() {
    return this._semaphore.cancel();
  }, n;
}(), K = Object.defineProperty, G = (n, t, e) => t in n ? K(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e, m = (n, t, e) => (G(n, typeof t != "symbol" ? t + "" : t, e), e);
const z = "CONNECT", V = "DEFAULT";
function W(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var T = { exports: {} };
(function(n) {
  var t = (() => {
    var e = Object.defineProperty, s = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable, h = (g, d, _) => d in g ? e(g, d, { enumerable: !0, configurable: !0, writable: !0, value: _ }) : g[d] = _, v = (g, d) => {
      for (var _ in d || (d = {}))
        r.call(d, _) && h(g, _, d[_]);
      if (s)
        for (var _ of s(d))
          i.call(d, _) && h(g, _, d[_]);
      return g;
    }, w = (g) => e(g, "__esModule", { value: !0 }), o = (g, d) => {
      w(g);
      for (var _ in d)
        e(g, _, { get: d[_], enumerable: !0 });
    }, p = {};
    o(p, {
      DEFAULT_UUID_LENGTH: () => E,
      default: () => S
    });
    var y = "4.4.4", E = 6, H = {
      dictionary: "alphanum",
      shuffle: !0,
      debug: !1,
      length: E
    }, x = class extends Function {
      constructor(g = {}) {
        super(), this.dictIndex = 0, this.dictRange = [], this.lowerBound = 0, this.upperBound = 0, this.dictLength = 0, this._digit_first_ascii = 48, this._digit_last_ascii = 58, this._alpha_lower_first_ascii = 97, this._alpha_lower_last_ascii = 123, this._hex_last_ascii = 103, this._alpha_upper_first_ascii = 65, this._alpha_upper_last_ascii = 91, this._number_dict_ranges = {
          digits: [this._digit_first_ascii, this._digit_last_ascii]
        }, this._alpha_dict_ranges = {
          lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii],
          upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
        }, this._alpha_lower_dict_ranges = {
          lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii]
        }, this._alpha_upper_dict_ranges = {
          upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
        }, this._alphanum_dict_ranges = {
          digits: [this._digit_first_ascii, this._digit_last_ascii],
          lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii],
          upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
        }, this._alphanum_lower_dict_ranges = {
          digits: [this._digit_first_ascii, this._digit_last_ascii],
          lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii]
        }, this._alphanum_upper_dict_ranges = {
          digits: [this._digit_first_ascii, this._digit_last_ascii],
          upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
        }, this._hex_dict_ranges = {
          decDigits: [this._digit_first_ascii, this._digit_last_ascii],
          alphaDigits: [this._alpha_lower_first_ascii, this._hex_last_ascii]
        }, this.log = (...a) => {
          const c = [...a];
          if (c[0] = `[short-unique-id] ${a[0]}`, this.debug === !0 && typeof console < "u" && console !== null)
            return console.log(...c);
        }, this.setDictionary = (a, c) => {
          let u;
          if (a && Array.isArray(a) && a.length > 1)
            u = a;
          else {
            u = [];
            let f;
            this.dictIndex = f = 0;
            const M = `_${a}_dict_ranges`, N = this[M];
            Object.keys(N).forEach((R) => {
              const q = R;
              for (this.dictRange = N[q], this.lowerBound = this.dictRange[0], this.upperBound = this.dictRange[1], this.dictIndex = f = this.lowerBound; this.lowerBound <= this.upperBound ? f < this.upperBound : f > this.upperBound; this.dictIndex = this.lowerBound <= this.upperBound ? f += 1 : f -= 1)
                u.push(String.fromCharCode(this.dictIndex));
            });
          }
          c && (u = u.sort(() => Math.random() - 0.5)), this.dict = u, this.dictLength = this.dict.length, this.counter = 0;
        }, this.seq = () => this.sequentialUUID(), this.sequentialUUID = () => {
          let a, c, u = "";
          a = this.counter;
          do
            c = a % this.dictLength, a = Math.trunc(a / this.dictLength), u += this.dict[c];
          while (a !== 0);
          return this.counter += 1, u;
        }, this.randomUUID = (a = this.uuidLength || E) => {
          let c, u, f;
          if (a === null || typeof a > "u" || a < 1)
            throw new Error("Invalid UUID Length Provided");
          for (c = "", f = 0; f < a; f += 1)
            u = parseInt((Math.random() * this.dictLength).toFixed(0), 10) % this.dictLength, c += this.dict[u];
          return c;
        }, this.availableUUIDs = (a = this.uuidLength) => parseFloat(Math.pow([...new Set(this.dict)].length, a).toFixed(0)), this.approxMaxBeforeCollision = (a = this.availableUUIDs(this.uuidLength)) => parseFloat(Math.sqrt(Math.PI / 2 * a).toFixed(20)), this.collisionProbability = (a = this.availableUUIDs(this.uuidLength), c = this.uuidLength) => parseFloat((this.approxMaxBeforeCollision(a) / this.availableUUIDs(c)).toFixed(20)), this.uniqueness = (a = this.availableUUIDs(this.uuidLength)) => {
          const c = parseFloat((1 - this.approxMaxBeforeCollision(a) / a).toFixed(20));
          return c > 1 ? 1 : c < 0 ? 0 : c;
        }, this.getVersion = () => this.version, this.stamp = (a) => {
          if (typeof a != "number" || a < 10)
            throw new Error("Param finalLength must be number greater than 10");
          const c = Math.floor(+new Date() / 1e3).toString(16), u = a - 9, f = Math.round(Math.random() * (u > 15 ? 15 : u)), M = this.randomUUID(u);
          return `${M.substr(0, f)}${c}${M.substr(f)}${f.toString(16)}`;
        }, this.parseStamp = (a) => {
          if (a.length < 10)
            throw new Error("Stamp length invalid");
          const c = parseInt(a.substr(a.length - 1, 1), 16);
          return new Date(parseInt(a.substr(c, 8), 16) * 1e3);
        };
        const d = v(v({}, H), g);
        this.counter = 0, this.debug = !1, this.dict = [], this.version = y;
        const {
          dictionary: _,
          shuffle: k,
          length: P
        } = d;
        return this.uuidLength = P, this.setDictionary(_, k), this.debug = d.debug, this.log(this.dict), this.log(`Generator instantiated with Dictionary Size ${this.dictLength}`), new Proxy(this, {
          apply: (a, c, u) => this.randomUUID(...u)
        });
      }
    }, S = x;
    return S.default = x, p;
  })();
  n.exports = t.default, typeof window < "u" && (t = t.default);
})(T);
const X = /* @__PURE__ */ W(T.exports), C = new X({ length: 10 });
class O {
  constructor(t, e) {
    m(this, "connection"), m(this, "channelId"), m(this, "boundMessageHandler"), m(this, "onMessageHandlers", []), m(this, "resolveConnection"), m(this, "channelNodeId"), m(this, "crossOrigin"), m(this, "message", (s, r, i) => this.crossOrigin ? this.postMessage(s, r, i) : this.customEventMessage(s, r, i)), this.channelId = t != null ? t : V, this.channelNodeId = `channel-node-${C()}`, this.crossOrigin = e, this.connection = new Promise((s) => {
      this.resolveConnection = s;
    }), this.boundMessageHandler = this.handleMessage.bind(this);
  }
  disconnect() {
    this.onMessageHandlers = [], window.removeEventListener(this.channelId, this.boundMessageHandler), this.connection = new Promise((t) => {
      this.resolveConnection = t;
    });
  }
  onMessage(t) {
    this.onMessageHandlers.push(t);
  }
  removeMessageHandler(t) {
    const e = this.onMessageHandlers.findIndex(
      (s) => s === t
    );
    this.onMessageHandlers.splice(e, 1);
  }
  customEventMessage(t, e, s) {
    const r = new CustomEvent(this.channelId, {
      detail: {
        eventId: s,
        channelId: this.channelId,
        channelNodeId: this.channelNodeId,
        name: t,
        data: e
      }
    });
    window.dispatchEvent(r);
  }
  postMessage(t, e, s) {
    var r, i, h;
    (h = (r = this.crossOrigin) == null ? void 0 : r.window) == null || h.postMessage(
      {
        eventId: s,
        channelId: this.channelId,
        channelNodeId: this.channelNodeId,
        name: t,
        data: e
      },
      (i = this.crossOrigin) == null ? void 0 : i.targetOrigin
    );
  }
  async eventRequest(t, e) {
    const s = C();
    return new Promise((r) => {
      const i = (h) => {
        const { eventId: v } = h;
        s === v && (this.removeMessageHandler(i), r(h));
      };
      this.onMessage(i), this.message(t, e, s);
    });
  }
  async waitForEvent(t) {
    return new Promise((e) => {
      const s = (r) => {
        const { name: i } = r;
        t === i && (this.removeMessageHandler(s), e(r));
      };
      this.onMessage(s);
    });
  }
  handleMessage(t) {
    var e;
    let s;
    if (O.isCustomEvent(t))
      s = t.detail;
    else {
      if (this.crossOrigin && !this.crossOrigin.targetOrigin.includes(t.origin) && ((e = this.crossOrigin) == null ? void 0 : e.targetOrigin) !== "*")
        return;
      s = t.data;
    }
    const {
      channelId: r,
      channelNodeId: i
    } = s;
    this.channelId === r && this.channelNodeId !== i && this.onMessageHandlers.forEach((h) => {
      h(s);
    });
  }
  static isCustomEvent(t) {
    return t.detail !== void 0;
  }
}
class J extends O {
  connect(t) {
    return window.addEventListener(
      this.crossOrigin ? "message" : this.channelId,
      this.boundMessageHandler
    ), this.waitForEvent(z).then((e) => {
      this.message(
        "CONNECTION_EVENT_RESPONSE",
        t,
        e.eventId
      ), this.resolveConnection(e);
    }), this.connection;
  }
}
var D;
(function(n) {
  n.LOCAL_CONTENT = "local-content", n.DATA_EXPLORER = "data-explorer";
})(D || (D = {}));
var b;
(function(n) {
  n.GET_STATE = "get-state", n.GET_STATE_RESPONSE = "get-state-response", n.SET_STATE = "set-state", n.ON_CHANGE = "on-change";
})(b || (b = {}));
class Q {
  constructor(t, e, s) {
    l(this, "leaderNode");
    l(this, "defaultState");
    l(this, "onMessageHandlers", []);
    l(this, "isConnected");
    l(this, "clientLock");
    this.leaderNode = new J(
      e != null ? e : "ll-state-manager",
      s
    ), this.leaderNode.connect(t), this.defaultState = t, this.isConnected = this.leaderNode.connection, this.clientLock = new j();
  }
  async setState(t) {
    await this.leaderNode.connection;
    const e = await this.clientLock.acquire(), s = await this.getState(), r = t(s);
    this.leaderNode.message(b.SET_STATE, r), e();
  }
  async getState() {
    return await this.leaderNode.connection, (await this.leaderNode.eventRequest(
      b.GET_STATE
    )).data;
  }
  async onChange(t) {
    await this.leaderNode.connection, this.leaderNode.onMessage((e) => {
      e.name === b.ON_CHANGE && t(e.data);
    });
  }
  destroy() {
    this.leaderNode.disconnect();
  }
}
function U(n) {
  const t = {};
  return Promise.race([n, t]).then(
    (e) => e === t ? "pending" : "fulfilled",
    () => "rejected"
  );
}
class Y {
  constructor(t, e, s, r = { lazy: !0 }) {
    l(this, "options");
    l(this, "renderOptions");
    l(this, "stateManager");
    l(this, "renderedElement");
    l(this, "renderTo");
    l(this, "lazyInterval");
    l(this, "hasMounted");
    l(this, "hasMountedResolve");
    l(this, "hasMountedReject");
    l(this, "renderHandler");
    this.options = s, this.renderTo = e, this.renderOptions = r, this.hasMounted = new Promise((i, h) => {
      this.hasMountedResolve = i, this.hasMountedReject = h;
    }), r.lazy ? (this.renderHandler = async () => {
      const i = await U(this.hasMounted);
      this.isInViewport() && i === "pending" && (this.renderedElement = this.mount(t, e), clearInterval(this.lazyInterval));
    }, this.renderHandler(), this.lazyInterval = setInterval(this.renderHandler, 500)) : this.renderedElement = this.mount(t, e);
  }
  async update(t) {
    var e;
    await this.hasMounted, (e = this.stateManager) == null || e.setState((s) => ({
      ...s,
      options: {
        ...s.options,
        ...t
      }
    }));
  }
  async on(t, e) {
    var s;
    await this.hasMounted, t === "change" && ((s = this.stateManager) == null || s.onChange(e));
  }
  async destroy() {
    var t, e;
    await U(this.hasMounted), this.hasMountedReject("SDK has already been destroyed."), this.renderHandler && document.removeEventListener("scroll", this.renderHandler), (t = this.stateManager) == null || t.destroy(), (e = this.renderedElement) == null || e.remove();
  }
  mount(t, e) {
    this.hasMountedResolve();
    const s = {
      development: "http://localhost:3001",
      staging: "https://staging.locallogic.co",
      production: "https://sdk.locallogic.co"
    }, r = `chn-${Math.random() * 100}`, i = `sdks-app/v1/${t}?channelId=${r}`, h = s.production, v = `${h}/${i}`, w = document.createElement("iframe");
    w.src = v, w.name = "Local Logic SDK", w.title = "Local Logic SDK", w.style.cssText = `
    width: 100%;
    height: 100%;
    border: none;
    `, e.appendChild(w);
    const { contentWindow: o } = w;
    return this.stateManager = new Q(this.options, r, {
      targetOrigin: h,
      window: o
    }), w;
  }
  isInViewport() {
    const t = this.renderTo.getBoundingClientRect();
    return (window.innerHeight || document.documentElement.clientHeight) - t.top >= 0;
  }
}
class Z {
  constructor(t, e) {
    l(this, "apiKey");
    l(this, "globalOptions");
    l(this, "registeredSDKs", []);
    this.apiKey = t, this.globalOptions = e;
  }
  create(t, e, s, r) {
    const i = new Y(
      t,
      e,
      {
        apiKey: this.apiKey,
        globalOptions: this.globalOptions,
        options: s
      },
      r
    );
    return this.registeredSDKs.push(i), i;
  }
  update(t) {
    this.registeredSDKs.forEach(async (e) => {
      var s;
      await e.hasMounted, (s = e.stateManager) == null || s.setState((r) => ({
        ...r,
        globalOptions: {
          ...r.globalOptions,
          ...t
        }
      }));
    });
  }
}
const et = (n, t) => new Z(n, t);
export {
  et as default
};
